export default __webpack_public_path__ + "static/media/cd4b21e95186aab2.4eef715809309644f844b0bea8938c3a.svg";